import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ProblemReframe } from './components/ProblemReframe';
import { HowItWorks } from './components/HowItWorks';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { BuiltForBoth } from './components/BuiltForBoth';
import { BonusPack } from './components/BonusPack';
import { OfferSummary } from './components/OfferSummary';
import { GetStarted } from './components/GetStarted';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-navy-900 font-sans antialiased" data-id="element-0" data-mp="2wiyy8vkq9zd9">
      <SiteHeader data-id="element-1" data-mp="28u5vaf5our95" />
      <main data-id="element-2" data-mp="28te198rqp1kz">
        <Hero data-id="element-3" data-mp="28t4l0cwhy8sh" />
        <ProblemReframe data-id="element-4" data-mp="28sl3uyeo7ofi" />
        <HowItWorks data-id="element-5" data-mp="28s31dk1f0dz5" />
        <WhatsInside data-id="element-6" data-mp="23vune9yyeqtk" />
        <LookInside data-id="element-7" data-mp="23u9vks40xlze" />
        <BuiltForBoth data-id="element-8" data-mp="23ut9lxqjzq85" />
        <BonusPack data-id="element-9" data-mp="23ti7e2craqj5" />
        <OfferSummary data-id="element-10" data-mp="3ik7ekc2063oj" />
        <GetStarted data-id="element-11" data-mp="3iiwdwl3utc1n" />
        <Faq data-id="element-12" data-mp="3ijfv1zlojwem" />
        <FinalCta data-id="element-13" data-mp="3ihv1odb3qjic" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3mlavz2zp87rv" />
    </div>;
}